export {};
//# sourceMappingURL=searchConfig.js.map